import { PrBannerResponse } from '@doda/common/src/interfaces/prBanner';

/**
 * PrBannerコンポーネントに渡すpropsを返す
 * @param prBannerData
 * @returns PRバナーデータ
 */
export const getPrBannerProps = (prBannerData: PrBannerResponse | null) => {
  const prBanner = prBannerData?.prJobData;
  const prBannerLinkUrl = prBanner?.prBannerLinkUrl;
  const prBannerImagePath = prBanner?.prBannerImagePath;
  const prBannerJobText = prBanner?.prBannerJobText;

  return {
    prBannerLinkUrl,
    prBannerImagePath,
    prBannerJobText,
  };
};
